"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var done_icon_dark_svg_1 = __importDefault(require("res/img/done-icon-dark.svg"));
var Button_1 = __importDefault(require("components/common/buttons/Button"));
var Loading_1 = __importDefault(require("components/Loading"));
var TextInput_1 = __importDefault(require("components/common/inputs/TextInput"));
var ProductOptionForm = function (_a) {
    var data = _a.data, onChange = _a.onChange, onSubmit = _a.onSubmit, busy = _a.busy, success = _a.success;
    return (react_1.default.createElement("div", { className: 'product-option-form form' },
        react_1.default.createElement("p", null, "Enter a name for the product option group. You can add items to this group on the next screen."),
        react_1.default.createElement("div", { className: 'form__inputs', "data-busy": busy || success },
            react_1.default.createElement(TextInput_1.default, { type: 'text', name: 'name', placeholder: 'Specification Name', value: data.name || '', onChange: onChange })),
        react_1.default.createElement(Button_1.default, { type: 'button', icon: busy ? react_1.default.createElement(Loading_1.default, null) : success ? react_1.default.createElement("img", { src: done_icon_dark_svg_1.default, alt: 'Done' }) : null, onClick: onSubmit, title: 'Create Product Option' }, "Create Option")));
};
exports.default = ProductOptionForm;
